var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10_12589)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    rx: 42,
    fill: "#ECF0E6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    rx: 42,
    stroke: "#97C196",
    strokeLinecap: "square",
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_10_12589)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49 37V39.99C49 39.99 47.01 40 47 39.99V37H44C44 37 44.01 35.01 44 35H47V32H49V35H52V37H49ZM46 41V38H43V35H35C33.9 35 33 35.9 33 37V49C33 50.1 33.9 51 35 51H47C48.1 51 49 50.1 49 49V41H46ZM35 49L38 45L40 48L43 44L47 49H35Z",
    fill: "#97C196"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10_12589"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    rx: 6,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_10_12589"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(30 30)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploader);
export default __webpack_public_path__ + "static/media/uploader.a331f204f704e7a0836b41b62b52acf1.svg";
export { ForwardRef as ReactComponent };